// Utilities
function debounce(fn, wait) {
  let timeout;

  return (...args) => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      fn(...args);
    }, wait);
  };
}
  
function trackGlobalSearchResults(query, count){
  if (typeof segment !== "function") return;
  segment()?.track("Search Results", { query, count });
};

function trackGlobalSearch(query, source){
  if (typeof segment !== "function") return;
  segment()?.track("Search", { query, source });
};

function trackGlobalSearchClear(query, count){
  if (typeof segment !== "function") return;
  segment()?.track("Search Results Cleared", {
    query,
    count,
  });
};

window.themeUtils = {
  debounce,
  trackGlobalSearchResults,
  trackGlobalSearch,
  trackGlobalSearchClear
};